<h2 mat-dialog-title>{{data.label}} Subscription</h2>
<mat-dialog-content class="mat-typography">
  <p>Please confirm if you want to {{data.label}} your subscription</p>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>